import PropTypes from "prop-types"

export const LibraryCategoryType = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
}
